import { styled } from "twin.macro"

const ContentWrapper = styled.div`
  max-width: 868px;
  margin: 0 auto;
`

export default ContentWrapper
